import { ajax } from '@/plugins/ajax';

export default {
    namespaced: true,
    actions: {
        createRecruitmentForm({ commit, dispatch }, model) {
            return ajax.post('HRM/api/Recruitments', model).then(r => {
            })
        },
    },
}
